// extracted by mini-css-extract-plugin
module.exports = {"cursorLayer":"style_cursorLayer__uBDoI","cursor":"style_cursor__c3YxG","down":"style_down__UiNSN","right":"style_right__hzeuA","selectionLayer":"style_selectionLayer__yv_XA"};